// Cookies are scoped by host/path, not by port. Product namespaces are
// transport configuration only; they never define business data scope.
export function productSessionCookies(code) {
    if (code !== "vla" && code !== "western")
        throw new TypeError("Unsupported product code for session cookies");
    return Object.freeze({
        session: `ilabel_${code}_session`,
        csrf: `ilabel_${code}_csrf`,
    });
}
//# sourceMappingURL=session-cookies.js.map